import { Skeleton, useTheme } from '@mui/material';

const ProductAddOnSkeleton = () => {
  const theme = useTheme();
  const color = 'grey.100';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height="48px"
        sx={{ bgcolor: color }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height="140px"
        sx={{ bgcolor: color }}
      />
    </div>
  );
};

export default ProductAddOnSkeleton;
